import { useMutation } from "@tanstack/react-query";
import { getWeekSchedule } from "../../queries/ScheduleHub";

interface IGetHubWeekScheduleParams {
  idCronograma: string;
  startDate: Date;
  endDate: Date;
}

export const useGetHubWeekSchedule = () => {
  const { data, isPending, isError, mutate } = useMutation({
    mutationKey: ['getHubWeekSchedule'],
    mutationFn: (params: IGetHubWeekScheduleParams) => getWeekSchedule(params.idCronograma, params.startDate, params.endDate),
    retry: false,
  });

  return { mutate, isPending, isError, data };
};